export interface GoodsItem {
  title: string;
  // pricePerMonth: string;
  // bundledPrice: string;
  hasHotFlag: boolean;
  stylizedPricePerMonth: string;
  formattedBundledPrice: string;
  skuData: any;
  active: boolean;
  unit: string;
  isBestValue?: boolean;
  offSrc?: string;
  id: number;
  total: any;
}

export enum UserSubscribeStatus {
  NOT_SUBSCRIBE = 0,
  SUBSCRIBING = 1,
}

export enum UserVipStatus {
  IS_NOT_VIP = 0,
  IS_VIP = 1,
}

// 订单状态
export enum payStatusMap {
  LOADING, // 待支付
  CANCEL, // 1已取消
  OK, // 2已支付
  REFUNDING, // 3退款中
  REFUND, // 4已退款
  FILL_INFO, // 5需补充信息
}
export enum performStatusMap {
  DOING = 0, // 待履约
  DONE = 1, // 已履约
}

export enum DefaultSubscribe {
  Year = 0,
  HALFYEAR = 1,
  MONTH = 2,
}
